/**
 * Global
 * ------
 */
$('a[href*="#"]:not([href="#"])').click(function () {
  if (!$(this).hasClass("nav-link")) {
    var target = $(this.hash);
    $("html,body").animate({
      scrollTop: target.offset().top - 80,
    });
  }
});
if (location.hash) {
  var id = $(location.hash);
}
$(window).on("load", function () {
  if (location.hash) {
    $("html,body").animate({ scrollTop: id.offset().top - 80 });
  }
});

$(".nav-pills .nav-link").on("click", function (e) {
  e.preventDefault();
  $(this).tab("show");
});

$(".tab-block .nav-link").on("click", function (e) {
  var btnText = $(this).text().trim();

  if ($(this).find(".nav-text").length > 0) {
    btnText = $(this).find(".nav-text").text();
  }
  dataLayer.push({
    event: "TabbedSliderClick",
    buttonText: btnText,
  });
});
